import type { GeoJSONPolygon } from '../types/api.types';

/**
 * Lee el primer polígono de un KML (`<Polygon>` o, si no hay, la primera
 * `<LineString>` cerrada) y lo devuelve como GeoJSON [lng, lat]. null si no hay
 * un anillo utilizable (menos de 3 vértices distintos o coordenadas inválidas).
 */
export function parseKmlPolygon(kmlText: string): GeoJSONPolygon | null {
  const doc = new DOMParser().parseFromString(kmlText, 'application/xml');
  if (doc.getElementsByTagName('parsererror').length) return null;

  const holder = doc.getElementsByTagName('Polygon')[0] ?? doc.getElementsByTagName('LineString')[0];
  const raw = holder?.getElementsByTagName('coordinates')[0]?.textContent;
  if (!raw) return null;

  const ring: [number, number][] = [];
  for (const tuple of raw.trim().split(/\s+/)) {
    const [lng, lat] = tuple.split(',').map(Number);
    if (!Number.isFinite(lng) || !Number.isFinite(lat) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
    ring.push([lng, lat]);
  }
  const first = ring[0], last = ring[ring.length - 1];
  const closed = ring.length > 1 && first[0] === last[0] && first[1] === last[1];
  if ((closed ? ring.length - 1 : ring.length) < 3) return null;
  if (!closed) ring.push([first[0], first[1]]);
  return { type: 'Polygon', coordinates: [ring] };
}
